import React, { useMemo } from "react";
import CustomCard from "../Card";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../molecules/ReactEchart";

const CombinedStatus: React.FC = React.memo(() => {
  const options: EChartsOption = useMemo(() => {
    const fullLabels = [
      "AGC - Residential",
      "Manazil Al Raffa 01",
      "Bayt Al Muteena 01",
      "Manazil Al Raffa 02",
      "Masaken Al Muraqqabat",
      "Masaken Al Warqa",
      "Manazil Al Barsha 01",
      "Masaken Al Muraqqabat 02",
      "Manazil Al Barsha 02",
      "Manazil Mankhool 01",
    ];

    const shortLabels = [
      "AGC",
      "Raffa",
      "Muteena",
      "Raffa",
      "Muraqqabat",
      "Warqa",
      "Barsha",
      "Muraqqabat",
      "Barsha",
      "Mankhool",
    ];

    const isMobile = window.innerWidth < 600;
    const categoryNames = isMobile ? shortLabels : fullLabels;

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (params: any) => {
          return params
            .map((p: any) => `${p.seriesName}: ${p.value}K`)
            .join("<br/>");
        },
      },
      legend: {
        top: 0,
        left: "center",
        icon: "circle",
        itemGap: 20,
        textStyle: {
          fontSize: 14,
          color: "#1F5782",
          fontWeight: "bold",
        },
      },
      grid: {
        top: 80,
        left: "3%",
        right: "5%",
        bottom: "5%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        splitLine: { show: false },
      },
      yAxis: {
        type: "category",
        inverse: true,
        data: categoryNames,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: 14,
          color: "#1F5782",
        },
      },
      series: [
        {
          name: "Air Conditioning",
          type: "bar",
          stack: "total",
          data: [0.3, 0.5, 1.3, 0.3, 0.5, 1.3, 0.3, 0.2, 0.2, 0.2],
          barWidth: "50%",
          itemStyle: { color: "#0E3D5D" },
          label: {
            show: true,
            position: "inside",
            color: "#fff",
            fontWeight: "bold",
            formatter: ({ value }) => `${value}`,
          },
        },
        {
          name: "Carpentry",
          type: "bar",
          stack: "total",
          data: [0.6, 0.6, 0.8, 0.6, 0.6, 0.6, 0.6, 0.4, 0.3, 0.2],
          itemStyle: { color: "#2F6D94" },
          label: {
            show: true,
            position: "inside",
            color: "#fff",
            fontWeight: "bold",
            formatter: ({ value }) => `${value}`,
          },
        },
        {
          name: "Electrical",
          type: "bar",
          stack: "total",
          data: [0.6, 0.6, 0.9, 0.6, 0.6, 0.3, 0.6, 0.3, 0.2, 0.1],
          itemStyle: { color: "#FFC107" },
          label: {
            show: true,
            position: "inside",
            color: "#000",
            fontWeight: "bold",
            formatter: ({ value }) => `${value}`,
          },
        },
        {
          name: "Masonry",
          type: "bar",
          stack: "total",
          data: [1.6, 1.3, 0.9, 1.2, 0.6, 0.3, 0.6, 0.3, 0.2, 0.2],
          itemStyle: { color: "#6CAAD8" },
          label: {
            show: true,
            position: "inside",
            color: "#fff",
            fontWeight: "bold",
            formatter: ({ value }) => `${value}`,
          },
        },
        {
          name: "Painting",
          type: "bar",
          stack: "total",
          data: [0.3, 0.2, 0.4, 0.2, 0.4, 0.3, 0.3, 0.3, 0.2, 0.1],
          itemStyle: { color: "#FFAB91" },
          label: {
            show: true,
            position: "inside",
            color: "#000",
            fontWeight: "bold",
            formatter: ({ value }) => `${value}`,
          },
        },
      ],
      dataZoom: [
        {
          type: "inside",
          yAxisIndex: 0,
          start: 0,
          end:
            categoryNames.length > 6 ? (6 / categoryNames.length) * 100 : 100,
        },
        {
          type: "slider",
          yAxisIndex: 0,
          start: 0,
          end:
            categoryNames.length > 6 ? (6 / categoryNames.length) * 100 : 100,
          right: 10,
          width: 10,
        },
      ],
    };
  }, []);

  return (
    <CustomCard heading="CASE /" subHeading="STATUS">
      <ReactEchart
        options={options}
        style={{ height: "500px", width: "100%" }}
      />
    </CustomCard>
  );
});

export default CombinedStatus;
